export const TITLE = "Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno";

export const META_NAME = "description";

export const META_KEYWORDS_NAME = "keywords";

export const META_KEYWORDS_CONTENT =
  "montra electric auto, montra electric super auto, montra electric auto, montra electric, montra electric auto price, montra electric 3 wheeler, montra super auto, montra electric vehicle, montra electric auto price in india, montra electric auto specifications, montra electric auto range, montra electric auto features";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "montra electric auto, montra electric super auto, montra electric auto, montra electric, montra electric auto price, montra electric 3 wheeler, montra super auto, montra electric vehicle, montra electric auto price in india, montra electric auto specifications, montra electric auto range, montra electric auto features",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Montra/super-auto",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Montra/super-auto",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Montra/super-auto",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADER = "Highlights of Montra Electric Auto";

export const SUB_TEXT =
  "The Montra Super Auto is a three-wheeler electric passenger auto. On a single charge, it gives an approximate range of 160+ km and a top speed of 55 km/h. This electric auto is quite spacious, with plenty of leg, head, and boot space for driver, passengers, and their luggage.";

export const BENEFITS_HEADER = "Vehicle Benefits of Montra Electric Auto";

export const VEHICLE_FEATURE_HEADER = "Features of Montra Super Auto";

export const BRAND_DEALER_HEADER = "Montra Super Auto Dealers Near Me: ";

export const BRAND_DEALER_DESCRIPITION =
  "You can find many Montra dealers near you but if you want the best EV buying and owning experience, you must visit Turno, India’s No.1 EV Dealer. At Turno, we don’t only sell EVs, we also provide excellent after-sale support such as assured vehicle buyback, dedicated relationship manager, arranging roadside assistance and additional EV services.";

export const FAQ_HEADER_TEXT = "FAQs on Montra Super Auto";

export const H1_HEADING = "Montra Super Auto";

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Montra/super-auto";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Montra Super Auto", href: VEHICLE_LINK },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Montra Super Auto",
      item: VEHICLE_LINK,
    },
  ],
};